/** Map UI locale codes to prompt-translation API `language` values. */
export const TRANSLATION_API_LANGUAGE_BY_LOCALE = {
  ar: "Arabic",
  cn: "Simplified Chinese",
  zh: "Traditional Chinese",
  de: "German",
  en: "English",
  es: "Spanish",
  fr: "French",
  id: "Indonesian",
  it: "Italian",
  ja: "Japanese",
  kr: "Korean",
  nl: "Dutch",
  pt: "Portuguese",
  ru: "Russian",
  tr: "Turkish",
};

/** Subset supported by prompt-optimize API. */
export const OPTIMIZE_API_LANGUAGE_BY_LOCALE = {
  cn: "Simplified Chinese",
  zh: "Traditional Chinese",
  en: "English",
  ja: "Japanese",
  kr: "Korean",
  fr: "French",
  de: "German",
  ru: "Russian",
  es: "Spanish",
  pt: "Portuguese",
  it: "Italian",
};

export function resolveTranslationApiLanguage(localeCode, displayLabel) {
  return TRANSLATION_API_LANGUAGE_BY_LOCALE[localeCode] ?? displayLabel ?? "English";
}

export function resolveOptimizeApiLanguage(localeCode, displayLabel) {
  return (
    OPTIMIZE_API_LANGUAGE_BY_LOCALE[localeCode] ??
    TRANSLATION_API_LANGUAGE_BY_LOCALE[localeCode] ??
    displayLabel ??
    "English"
  );
}

export function extractTranslatedPrompt(data) {
  if (data == null) return "";
  if (typeof data === "string") return data.trim();
  if (Array.isArray(data)) {
    for (const item of data) {
      if (typeof item === "string" && item.trim()) return item.trim();
    }
    return "";
  }
  return String(
    data.prompt ?? data.text ?? data.result ?? data.translation ?? "",
  ).trim();
}
